import { configureStore } from '@reduxjs/toolkit';
import filterReducer from './filterSlice'; 
import userReducer from './userSlice'; 
const store = configureStore({
  reducer: {
    filter: filterReducer, 
    user: userReducer,
  },
});

export default store;
